import React from 'react';
import { Box } from '@chakra-ui/react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

interface BarChartProps {
  data: Record<string, number>;
  index?: 'x' | 'y';
  width?: string;
  height?: string;
}

export const BarChart: React.FC<BarChartProps> = ({
  data,
  index = 'x',
  width = '500px',
  height = '400px',
}) => {
  // Convert Record<string, number> to labels and dataset
  const labels = Object.keys(data);
  const values = Object.values(data);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Values',
        data: values,
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: index,
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
  };

  return (
    <Box width={width} height={height} margin="auto">
      <Bar data={chartData} options={options} />
    </Box>
  );
};
